import { InfoParcelas, pendencyType } from '@store/refinanciamento/simulacao/types'
import { BaseServices, HttpMethod } from '@services/base'

import { BridgeService } from './bridge'

export default (accessToken?: string) => {
  const pathname = process.env.REACT_APP_SIMULACAO_REFINANCIAMENTO
  const method = HttpMethod.GET
  const host = process.env.REACT_APP_API_HOST
  const headers: Record<string, string> = {}
  if (BridgeService.isBrowser() && accessToken) {
    headers.Authorization = `Bearer ${accessToken}`
  }

  const response = BaseServices.request<SimulacaoResponse>({
    headers,
    pathname,
    method,
    host,
  })
  return response
}

export interface Contracts {
  contractNumber: string
  installmentAmount: number
  debtBalance: number
}

export interface SimulacaoResponse {
  debtBalance: number
  pending?: pendencyType
  code?: string
  simulations: InfoParcelas[]
  simulationsWithInsurance: InfoParcelas[]
}
